/* src/app/workshop-defects/partials/workshop-defect-fitters/workshop-defect-fitters.component.scss */
.fitterChips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.fitterChip {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(249, 148, 32, 0.12);
  border: 1px solid rgba(249, 148, 32, 0.35);
  border-radius: 1rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
}
.fitterName {
  font-weight: 600;
  color: #212529;
}
.fitterDate {
  color: #6c757d;
}
.fitterHoursInput {
  width: 4rem;
  border: 1px solid rgba(249, 148, 32, 0.35);
  border-radius: 0.25rem;
  padding: 0.1rem 0.3rem;
  font-size: 0.8rem;
}
.fitterRemove {
  background: transparent;
  border: 0;
  color: #6c757d;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  padding: 0;
}
.fitterRemove:hover {
  color: #dc3545;
}
.addFitterRow {
  align-items: flex-start;
}
/*# sourceMappingURL=workshop-defect-fitters.component.css.map */
